import { render, staticRenderFns } from "./IframeResult.vue?vue&type=template&id=2331fc1a&"
import script from "./IframeResult.vue?vue&type=script&lang=js&"
export * from "./IframeResult.vue?vue&type=script&lang=js&"
import style0 from "./IframeResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports